import { Link } from 'react-router-dom'
import {ArrowRight} from 'lucide-react'
import Layout from '@/components/Layout'
import Container from '@/components/ui/Container'
import SectionHeading from '@/components/ui/SectionHeading'
import PageHero from '@/components/PageHero'
import TrustBar from '@/components/TrustBar'
import ConsultationForm from '@/components/ConsultationForm'
import { services } from '@/data/services'

function Services() {
  return (
    <Layout>
      <PageHero
        eyebrow="Serviços e Soluções"
        title="Soluções integradas de segurança e conectividade"
        description="Do diagnóstico ao suporte contínuo, cobrimos toda a jornada de segurança eletrônica e infraestrutura de rede da sua empresa."
      />

      <section className="py-20 sm:py-24">
        <Container>
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            {services.map((service) => {
              const Icon = service.icon
              return (
                <div key={service.id} className="flex flex-col overflow-hidden rounded-2xl border border-slate-100 shadow-sm transition-shadow hover:shadow-lg">
                  <div className="aspect-[16/9] overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-7">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan-600">
                      <Icon className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <h3 className="mt-4 text-xl font-semibold text-slate-900">{service.title}</h3>
                    <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{service.shortDescription}</p>
                    <Link
                      to={`/servicos/${service.slug}`}
                      className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-cyan-600 hover:underline"
                    >
                      Ver detalhes e estudo de caso
                      <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        </Container>
      </section>

      <TrustBar />

      <section className="bg-slate-50 py-20 sm:py-24">
        <Container className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <SectionHeading
              eyebrow="Fale com um especialista"
              title="Não sabe qual solução é ideal para você?"
              description="Nossos consultores avaliam gratuitamente as necessidades da sua empresa e recomendam a combinação de soluções mais eficiente."
            />
          </div>
          <div className="rounded-2xl bg-white p-6 shadow-xl sm:p-8">
            <ConsultationForm variant="full" />
          </div>
        </Container>
      </section>
    </Layout>
  )
}

export default Services
